export default __webpack_public_path__ + "static/media/landscape_thumbnail_placeholder_720x404.395be1cc.jpg";